import { DefaultImageProps } from './types';
import { DISCORD_IMAGE_URL } from './urls';

export const DiscordImage = ({ className, ...props }: DefaultImageProps) => (
  <img
    className={className}
    src={DISCORD_IMAGE_URL}
    alt="discord"
    {...props}
  />
);
